<template>
  <v-container
    class="pa-1"
    fluid
    grid-list-sm>
    <v-toolbar
      color="primary">
      <v-toolbar-title
        class="headline white--text">
        {{ $t("help_registries.de_minimis.header") + " " + $t(translation + ".header") }}
      </v-toolbar-title>
      <v-spacer/>

      <v-tooltip top>
        <template
          v-slot:activator="{ on, attrs }">
          <v-btn
            class="info"
            dark
            v-bind="attrs"
            v-on="on"
            :loading="reportDownloading"
            @click="downloadReport()">
            <v-icon class="white--text">mdi-download</v-icon>
            {{ $t(translation + ".download_report") }}
          </v-btn>
        </template>
        <span>{{ $t('tooltips.report') }}</span>
      </v-tooltip>
    </v-toolbar>
    <v-card class="pa-3" dark>
      <v-form
        ref="form"
        v-on:submit.prevent>
        <!--Korisnici pomoći i davaoci pomoći-->
        <v-row
          class="my-2"
        >
          <!--Korisnici pomoći-->
          <v-col
            cols="10"
            md="5"
            class="pr-1">

            <div
              class="px-1 pb-1"
              style="border: 1px dashed gray; border-radius: 5px; min-height: 50px;"
            >
              <div
                class="white--text pl-2 pt-1"
              >
                {{ $t('cb.help_receivers.header') }}
              </div>
              <v-chip
                v-for="helpReceiver in form.cb_help_receivers"
                :key="helpReceiver.id"
                class="pa-1 my-1"
                style="height: auto; white-space: normal;"
              >
                <div style="width: 100vh" class="ml-1">
                  {{
                    helpReceiver.pin + " - " + helpReceiver.name
                  }}
                </div>

                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="red--text"
                      @click="removeHelpReceiver(helpReceiver)"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                  <span>{{ $t('tooltips.delete') }}</span>
                </v-tooltip>


              </v-chip>
            </div>
          </v-col>
          <!--Odaberi korisnika pomoći-->
          <v-col
            cols="1"
            class="pl-1 py-0 mt-3"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="info py-5"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogCbHelpReceiverChooseItem()"
                >
                  <v-icon>mdi-archive-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
            </v-tooltip>
          </v-col>
          <!--Davaoci pomoći-->
          <v-col
            cols="10"
            md="5"
            class="pr-1">

            <div
              class="px-1 pb-1"
              style="border: 1px dashed gray; border-radius: 5px; min-height: 50px;"
            >
              <div
                class="white--text pl-2 pt-1"
              >
                {{ $t('cb.help_providers.header') }}
              </div>
              <v-chip
                v-for="helpProvider in form.cb_help_providers"
                :key="helpProvider.id"
                class="pa-1 my-1"
                style="height: auto; white-space: normal;"
              >
                <div style="width: 100vh" class="ml-1">
                  {{
                    helpProvider.name
                  }}
                </div>

                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-if="!cbHelpProvider"
                      v-bind="attrs"
                      v-on="on"
                      class="red--text"
                      @click="removeHelpProvider(helpProvider)"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                  <span>{{ $t('tooltips.delete') }}</span>
                </v-tooltip>


              </v-chip>
            </div>
          </v-col>
          <!--Odaberi davaoca pomoći-->
          <v-col
            v-if="!cbHelpProvider"
            cols="1"
            class="pl-1 py-0 mt-3">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="info py-5"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogCbHelpProviderChooseItem()"
                >
                  <v-icon>mdi-archive-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <!--Naziv mjere i rješenje agencije-->
        <v-row
          class="my-2"
        >
          <!--Naziv mjere-->
          <v-col
            cols="10"
            md="5"
            class="pr-1">

            <div
              class="px-1 pb-1"
              style="border: 1px dashed gray; border-radius: 5px; min-height: 50px;"
            >
              <div
                class="white--text pl-2 pt-1"
              >
                {{ $t('cb.help_measures.header') }}
              </div>
              <v-chip
                v-for="helpMeasure in form.cb_help_measures"
                :key="helpMeasure.id"
                class="pa-1 my-1"
                style="height: auto; white-space: normal;"
              >
                <div style="width: 100vh" class="ml-1">
                  {{
                    helpMeasure.name
                  }}
                </div>

                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="red--text"
                      @click="removeHelpMeasure(helpMeasure)"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                  <span>{{ $t('tooltips.delete') }}</span>
                </v-tooltip>


              </v-chip>
            </div>
          </v-col>
          <!--Odaberi nazive mjere-->
          <v-col
            cols="1"
            class="pl-1 py-0 mt-3"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="info py-5"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogCbHelpMeasureChooseItem()"
                >
                  <v-icon>mdi-archive-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
            </v-tooltip>
          </v-col>
          <!--Odluke davaoca-->
          <v-col
            cols="10"
            md="5"
            class="pr-1">

            <div
              class="px-1 pb-1"
              style="border: 1px dashed gray; border-radius: 5px; min-height: 50px;"
            >
              <div
                class="white--text pl-2 pt-1"
              >
                {{ $t('cb.provider_decisions.header') }}
              </div>
              <v-chip
                v-for="providerDecision in form.cb_provider_decisions"
                :key="providerDecision.id"
                class="pa-1 my-1"
                style="height: auto; white-space: normal;"
              >
                <div style="width: 100vh" class="ml-1">
                  {{
                    providerDecision.number
                  }}
                </div>

                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="red--text"
                      @click="removeProviderDecision(providerDecision)"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                  <span>{{ $t('tooltips.delete') }}</span>
                </v-tooltip>


              </v-chip>
            </div>
          </v-col>
          <!--Odaberi rješanje agencije-->
          <v-col
            cols="1"
            class="pl-1 py-0 mt-3">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="info py-5"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogCbProviderDecisionChooseItem()"
                >
                  <v-icon>mdi-archive-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <!--Vrsta pomoći i zaposleni davaoca-->
        <v-row
          class="my-2"
        >
          <!--Vrsta pomoći-->
          <v-col
            cols="10"
            md="5"
            class="pr-1">

            <div
              class="px-1 pb-1"
              style="border: 1px dashed gray; border-radius: 5px; min-height: 50px;"
            >
              <div
                class="white--text pl-2 pt-1"
              >
                {{ $t('cb.help_types.header') }}
              </div>
              <v-chip
                v-for="helpType in form.cb_help_types"
                :key="helpType.id"
                class="pa-1 my-1"
                style="height: auto; white-space: normal;"
              >
                <div style="width: 100vh" class="ml-1">
                  {{
                    helpType.name
                  }}
                </div>

                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="red--text"
                      @click="removeHelpType(helpType)"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                  <span>{{ $t('tooltips.delete') }}</span>
                </v-tooltip>


              </v-chip>
            </div>
          </v-col>
          <!--Odabir vrste pomoći-->
          <v-col
            cols="1"
            class="pl-1 py-0 mt-3">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="info py-5"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogCbHelpTypeChooseItem()"
                >
                  <v-icon>mdi-archive-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
            </v-tooltip>
          </v-col>
          <!--Zaposleni davaoca-->
          <v-col
            cols="10"
            md="5"
            class="pr-1">

            <div
              class="px-1 pb-1"
              style="border: 1px dashed gray; border-radius: 5px; min-height: 50px;"
            >
              <div
                class="white--text pl-2 pt-1"
              >
                {{ $t('users.cbHelpProviderUserHeader') }}
              </div>
              <v-chip
                v-for="user in form.users"
                :key="user.id"
                class="pa-1 my-1"
                style="height: auto; white-space: normal;"
              >
                <div style="width: 100vh" class="ml-1">
                  {{
                    user.name + " (" + user.username + ")"
                  }}
                </div>

                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="red--text"
                      @click="removeUser(user)"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                  <span>{{ $t('tooltips.delete') }}</span>
                </v-tooltip>


              </v-chip>
            </div>
          </v-col>
          <!--Odaberi zaposlenog davaoca-->
          <v-col
            cols="1"
            class="pl-1 py-0 mt-3">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="info py-5"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogUserChooseItem()"
                >
                  <v-icon>mdi-archive-arrow-up</v-icon>
                </v-btn>
              </template>
              <span>
                      {{ $t('tooltips.open_choose_dialog') }}
                    </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <!--Datum dodjele pomoći-->
        <v-row
          class="my-2"
        >
          <!--Datum dodjele pomoći od-->
          <v-col
            cols="11"
            md="5"
            class="py-0">
            <v-menu
              v-model="dateMenuDateFrom"
              dark
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.date_from"
                  dark
                  :label="$t(translation+'.date_from')"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.date_from"
                dark
                @input="dateMenuDateFrom = false"
                :max="new Date().toISOString().slice(0,10)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <!--Separator-->
          <v-col cols="1"/>
          <!--Datum dodjele pomoći do-->
          <v-col
            cols="11"
            md="5"
            class="py-0">
            <v-menu
              v-model="dateMenuDateTo"
              dark
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="form.date_to"
                  dark
                  :label="$t(translation+'.date_to')"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.date_to"
                dark
                @input="dateMenuDateTo = false"
                :max="new Date().toISOString().slice(0,10)"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <!---------------------------------- Choose cb_help_receiver item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpReceiverChooseDialog.showDialog"
      :singleSelect="cbHelpReceiverChooseDialog.singleSelect"
      :pre-selected="form.cb_help_receivers"
      :id="null"
      :translation="cbHelpReceiverChooseDialog.translation"
      :api="cbHelpReceiverChooseDialog.apiRead"
      :show-columns="cbHelpReceiverChooseDialog.showColumns"
      :headers="cbHelpReceiverChooseItemHeaders"
      :additional-parameters="cbHelpReceiverChooseDialog.additionalParameters"
      @closeChooseItemDialog="cbHelpReceiverChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpReceiverChosenEvent"
    />
    <!---------------------------------- Choose cb_help_providers item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpProviderChooseDialog.showDialog"
      :singleSelect="cbHelpProviderChooseDialog.singleSelect"
      :pre-selected="form.cb_help_providers"
      :id="null"
      :translation="cbHelpProviderChooseDialog.translation"
      :api="cbHelpProviderChooseDialog.apiRead"
      :show-columns="cbHelpProviderChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      :additional-parameters="cbHelpProviderChooseDialog.additionalParameters"
      @closeChooseItemDialog="cbHelpProviderChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpProviderChosenEvent"
    />
    <!---------------------------------- Choose cb_help_measure item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpMeasureChooseDialog.showDialog"
      :singleSelect="cbHelpMeasureChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpMeasureChooseDialog.translation"
      :api="cbHelpMeasureChooseDialog.apiRead"
      :show-columns="cbHelpMeasureChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpMeasureChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpMeasureChosenEvent"
    />
    <!---------------------------------- Choose cb_provider_decision item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="900"
      :dialogChooseItem="cbProviderDecisionChooseDialog.showDialog"
      :singleSelect="cbProviderDecisionChooseDialog.singleSelect"
      :id="null"
      :translation="cbProviderDecisionChooseDialog.translation"
      :api="cbProviderDecisionChooseDialog.apiRead"
      :show-columns="cbProviderDecisionChooseDialog.showColumns"
      :headers="cbProviderDecisionChooseItemHeaders"
      :sort-by-column="'number'"
      @closeChooseItemDialog="cbProviderDecisionChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbProviderDecisionChosenEvent"
    />
    <!---------------------------------- Choose cb_help_type item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="cbHelpTypeChooseDialog.showDialog"
      :singleSelect="cbHelpTypeChooseDialog.singleSelect"
      :id="null"
      :translation="cbHelpTypeChooseDialog.translation"
      :api="cbHelpTypeChooseDialog.apiRead"
      :show-columns="cbHelpTypeChooseDialog.showColumns"
      :headers="cbChooseItemHeaderName"
      @closeChooseItemDialog="cbHelpTypeChooseDialog.showDialog=false"
      @itemChosenEvent="onItemCbHelpTypeChosenEvent"
    />
    <!---------------------------------- Choose user item Dialog  ----------------------------------------->
    <dialog-choose-item
      :max-with-prop="600"
      :dialogChooseItem="userChooseDialog.showDialog"
      :singleSelect="userChooseDialog.singleSelect"
      :id="null"
      :translation="userChooseDialog.translation"
      :api="userChooseDialog.apiRead"
      :show-columns="userChooseDialog.showColumns"
      :headers="userChooseItemHeaderName"
      :additional-parameters="cbHelpProviderChooseDialog.additionalParameters"
      @closeChooseItemDialog="userChooseDialog.showDialog=false"
      @itemChosenEvent="onItemUserChosenEvent"
    />
    <!---------------------------------- Snackbar  ----------------------------------------->
    <v-snackbar
      v-model="snackbar.show"
      :bottom=true
      :color="snackbar.color"
      :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {add, edit, isEmptyObject, readTableDataPostPagination} from "../../../statics/DataTableFunctions";
import ChooseItemDialog from "../../../components/user/ChooseItemDialog";

export default {
  components: {
    'dialog-choose-item': ChooseItemDialog
  },
  name: "HelpRegistriesDeMimisReport",
  data() {
    return {
      translation: 'help_registries.report',
      apiRead: '/api/help_registries/de_minimis/index_pagination_provider',
      apiObject: '/api/help_registries/de_minimis/object',
      apiAdd: '/api/help_registries/de_minimis/store',
      apiEdit: '/api/help_registries/de_minimis/update',
      cbHelpProvider: null,
      loading: false,
      loadingData: false,
      reportDownloading: false,
      dateMenuDateFrom: false,
      dateMenuDateTo: false,
      totalKey: 0,
      form: {
        cb_help_receivers: [],
        cb_help_providers: [],
        cb_help_measures: [],
        cb_provider_decisions: [],
        cb_help_types: [],
        users: [],
        date_from: null,
        date_to: null
      },
      reportData: {
        folder: 'helpRegistries/deMinimis',
        name: 'helpRegistryDeMinimis',
        type: '.pdf'
      },
      moneyFloat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' €',
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      rules: {
        required: [
          v => !!v || this.$t('validation.field')
        ],
        gt_zero_lte_800k: [
          v => !!v || this.$t('validation.field'),
          v => this.isTotalValid(v) || this.$t('validation.field'),
        ],
        required_length: [
          v => !!v || this.$t('validation.field'),
          v => v === '' || v.length > 1 || this.$t(this.translation + '.validation')
        ],
      },
      show_columns: [
        "help_registries.id",
        "help_registries.total",
        "help_registries.date_from",
        "help_registries.date_to",
        "help_registries.is_active",
      ],
      show_columns_cb_help_measure_relation: [
        "name"
      ],
      show_columns_cb_help_receiver_relation: [
        "name",
        "pin"
      ],
      show_columns_cb_help_user_type_relation: [
        "name"
      ],
      show_columns_cb_activity_relation: [
        "name"
      ],
      show_columns_cb_help_provider_relation: [
        "name"
      ],
      show_columns_cb_help_status_relation: [
        "name"
      ],
      show_columns_cb_provider_decisions_relation: [
        "number"
      ],
      show_columns_cb_help_type_relation: [
        "name"
      ],
      show_columns_cb_help_goal_relation: [
        "name"
      ],
      cbHelpReceiverChooseDialog: {
        showDialog: false,
        singleSelect: false,
        translation: 'cb.help_receivers',
        apiRead: '/api/cb_help_receivers/index',
        showColumns: [
          "id",
          "name",
          "pin",
          "cb_activity_id",
          "cb_help_user_type_id"
        ],
        additionalParameters: null
      },
      cbHelpProviderChooseDialog: {
        showDialog: false,
        singleSelect: false,
        translation: 'cb.help_providers',
        apiRead: '/api/cb_help_providers/index',
        showColumns: [
          "id",
          "name"
        ],
        additionalParameters: null
      },
      cbHelpMeasureChooseDialog: {
        showDialog: false,
        singleSelect: false,
        translation: 'cb.help_measures',
        apiRead: '/api/cb_help_measures/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      cbProviderDecisionChooseDialog: {
        showDialog: false,
        singleSelect: false,
        translation: 'cb.provider_decisions',
        apiRead: '/api/cb_provider_decisions/index',
        showColumns: [
          "id",
          "number"
        ],
      },
      cbHelpTypeChooseDialog: {
        showDialog: false,
        singleSelect: false,
        translation: 'cb.help_types',
        apiRead: '/api/cb_help_types/index',
        showColumns: [
          "id",
          "name",
        ],
      },
      userChooseDialog: {
        showDialog: false,
        singleSelect: false,
        translation: 'users',
        apiRead: '/api/users/getDataUserSelect',
        showColumns: [
          "id",
          "name",
          "username"
        ]
      },
      snackbar: {
        color: 'success',
        show: false,
        text: '',
        timeout: 3000,
      },
    }
  },
  methods: {
    add,
    edit,
    isEmptyObject,
    readTableDataPostPagination,
    openDialogCbHelpReceiverChooseItem() {
      this.cbHelpReceiverChooseDialog.showDialog = true;
    },
    openDialogCbHelpProviderChooseItem() {
      this.cbHelpProviderChooseDialog.showDialog = true;
    },
    openDialogCbHelpMeasureChooseItem() {
      this.cbHelpMeasureChooseDialog.showDialog = true;
    },
    openDialogCbProviderDecisionChooseItem() {
      this.cbProviderDecisionChooseDialog.showDialog = true;
    },
    openDialogCbHelpTypeChooseItem() {
      this.cbHelpTypeChooseDialog.showDialog = true;
    },
    openDialogUserChooseItem() {
      this.userChooseDialog.showDialog = true;
    },
    onItemCbHelpReceiverChosenEvent(items) {
      this.form.cb_help_receivers = items;
      this.cbHelpReceiverChooseDialog.showDialog = false;
    },
    onItemCbHelpProviderChosenEvent(items) {
      this.form.cb_help_providers = items;
      this.cbHelpProviderChooseDialog.showDialog = false;
    },
    onItemCbHelpMeasureChosenEvent(items) {
      this.form.cb_help_measures = items;
      this.cbHelpMeasureChooseDialog.showDialog = false;
    },
    onItemCbProviderDecisionChosenEvent(items) {
      this.form.cb_provider_decisions = items;
      this.cbProviderDecisionChooseDialog.showDialog = false;
    },
    onItemCbHelpTypeChosenEvent(items) {
      this.form.cb_help_types = items;
      this.cbHelpTypeChooseDialog.showDialog = false;
    },
    onItemUserChosenEvent(users) {
      this.form.users = users;
      this.userChooseDialog.showDialog = false;
    },
    removeHelpReceiver(helpReceiver) {
      this.form.cb_help_receivers.splice(this.form.cb_help_receivers.findIndex(object => object.id === helpReceiver.id), 1);
    },
    removeHelpProvider(helpProvider) {
      this.form.cb_help_providers.splice(this.form.cb_help_providers.findIndex(object => object.id === helpProvider.id), 1);
    },
    removeHelpMeasure(helpMeasure) {
      this.form.cb_help_measures.splice(this.form.cb_help_measures.findIndex(object => object.id === helpMeasure.id), 1);
    },
    removeProviderDecision(providerDecision) {
      this.form.cb_provider_decisions.splice(this.form.cb_provider_decisions.findIndex(object => object.id === providerDecision.id), 1);
    },
    removeHelpType(helpType) {
      this.form.cb_help_types.splice(this.form.cb_help_types.findIndex(object => object.id === helpType.id), 1);
    },
    removeUser(user) {
      this.form.users.splice(this.form.users.findIndex(object => object.id === user.id), 1);
    },
    closeDialog() {
      this.totalKey = 0;
      this.form = {
        cb_help_receivers: [],
        cb_help_providers: [],
        cb_help_measures: [],
        cb_provider_decisions: [],
        cb_help_types: [],
        users: [],
        date_from: null,
        date_to: null
      }
      this.$refs.form.resetValidation()
      this.$emit('close')
    },
    onResponseFunction(response) {
      this.$emit(this.dataForModal ? 'editEmit' : 'addEmit', response.data);
      this.closeDialog();
      this.snackbar.color = 'success';
      this.snackbar.text = this.$t(this.dataForModal ? 'edit_success' : 'add_success');
      this.snackbar.show = true;
      this.loading = false;
    },
    onErrorFunction(error) {
      if (error.response.status === 401) {
        this.loading = false
        this.$swal.fire({
          type: 'info',
          title: "Info",
          text: this.$t('validation.session'),
        })
        this.$router.push('/login')
      } else {
        this.loading = false
        this.$swal.fire({
          type: 'error',
          title: this.$t('validation.error'),
          text: error.response.data.message,
        })
      }
    },
    generateReportFilters() {
      let reportFilters = {};
      if (this.form.cb_help_receivers.length > 0) {
        reportFilters['help_registries.cb_help_receiver_id'] = this.form.cb_help_receivers.map(cbHelpReceiver => {
          return cbHelpReceiver.id;
        })
      }
      if (this.form.cb_help_providers.length > 0) {
        reportFilters['help_registries.cb_help_provider_id'] = this.form.cb_help_providers.map(cbHelpProvider => {
          return cbHelpProvider.id;
        })
      }
      if (this.form.cb_help_measures.length > 0) {
        reportFilters['help_registries.cb_help_measure_id'] = this.form.cb_help_measures.map(cbHelpMeasure => {
          return cbHelpMeasure.id;
        })
      }
      if (this.form.cb_provider_decisions.length > 0) {
        reportFilters['help_registries.cb_provider_decision_id'] = this.form.cb_provider_decisions.map(cbProviderDecision => {
          return cbProviderDecision.id;
        })
      }
      if (this.form.cb_help_types.length > 0) {
        reportFilters['help_registries.cb_help_type_id'] = this.form.cb_help_types.map(cbHelpType => {
          return cbHelpType.id;
        })
      }
      if (this.form.users.length > 0) {
        reportFilters['help_registries.created_by_user_id'] = this.form.users.map(user => {
          console.log('user', user)
          return user.id;
        })
      }
      if (this.form.date_from) {
        reportFilters['date_from'] = this.form.date_from;
      }
      if (this.form.date_to) {
        reportFilters['date_to'] = this.form.date_to;
      }
      return reportFilters;
    },
    validateFilters() {
      const validateFilters = this.form.cb_help_receivers.length > 0 ||
        this.form.cb_help_providers.length > 0 ||
        this.form.cb_help_measures.length > 0 ||
        this.form.cb_provider_decisions.length > 0 ||
        this.form.cb_help_types.length > 0 ||
        this.form.users.length > 0;

      if (JSON.parse(localStorage.getItem('roles'))[0]['id'] === 1) {
        return validateFilters || (this.form.date_from != null || this.form.date_to != null)
      }
      return validateFilters;
    },
    downloadReport() {
      if (!this.validateFilters()) {
        this.$swal.fire({
          type: 'error',
          title: this.$t('report.filters.error.title'),
          text: this.$t('report.filters.error.text'),
        })
        return;
      }
      this.readTableDataPostPagination(
        this.apiRead,
        true,
        this.show_columns, {
          filters: null,
          report_filters: this.generateReportFilters(),
          options: {
            sortBy: {
              0: 'help_registries.date_from'
            },
            sortDesc: {
              0: false
            }
          },
          report_data: this.reportData,
          cb_help_status_id: 1,
          show_columns_cb_help_measure_relation: this.show_columns_cb_help_measure_relation,
          show_columns_cb_help_receiver_relation: this.show_columns_cb_help_receiver_relation,
          show_columns_cb_help_user_type_relation: this.show_columns_cb_help_user_type_relation,
          show_columns_cb_activity_relation: this.show_columns_cb_activity_relation,
          show_columns_cb_help_provider_relation: this.show_columns_cb_help_provider_relation,
          show_columns_cb_help_status_relation: this.show_columns_cb_help_status_relation,
          show_columns_cb_provider_decisions_relation: this.show_columns_cb_provider_decisions_relation,
          show_columns_cb_help_type_relation: this.show_columns_cb_help_type_relation,
          show_columns_cb_help_goal_relation: this.show_columns_cb_help_goal_relation
        },
        true
      )
    },
  },
  computed: {
    cbHelpReceiverChooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbHelpReceiverChooseDialog.translation + '.pin'),
          name: 'pin',
          align: 'left',
          value: 'pin'
        },
        {
          text: this.$t(this.cbHelpReceiverChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        }
      ]
    },
    cbChooseItemHeaderName() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbHelpReceiverChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
      ]
    },
    cbProviderDecisionChooseItemHeaders() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.cbProviderDecisionChooseDialog.translation + '.number'),
          name: 'number',
          align: 'left',
          value: 'number'
        },
      ]
    },
    userChooseItemHeaderName() {
      return [
        {
          text: this.$t('general.select'),
          name: 'actions',
          align: 'center',
          value: 'actions',
          width: '10px',
          sortable: false
        },
        {
          text: this.$t(this.userChooseDialog.translation + '.name'),
          name: 'name',
          align: 'left',
          value: 'name'
        },
        {
          text: this.$t(this.userChooseDialog.translation + '.username'),
          name: 'username',
          align: 'left',
          value: 'username'
        },
      ]
    },
  },
  created() {
    this.cbHelpProvider = localStorage.getItem('cb_help_provider') === 'null' ? null : localStorage.getItem('cb_help_provider');
    if (this.cbHelpProvider) {
      this.form.cb_help_providers.push(JSON.parse(this.cbHelpProvider));
      this.form.users.push({
        id: localStorage.getItem('u_id'),
        name: localStorage.getItem('name'),
        username: localStorage.getItem('username')
      });
    }
  }
}
</script>

<style>
</style>
